import { sumBy } from "lodash";
import React from "react";
import { Event } from "types";
import { InventoryName } from "./InventoryName";
import { ShowResourceNames } from "./ShowResourceNames";
import { getAggregatedResourceUsages } from "@/models/Event";

interface InventoryListProps {
    event: Event;
    showOnlyCount: boolean;
}

export const InventoryList = ({ event, showOnlyCount = false }: InventoryListProps) => {
    const groupedUsages = getAggregatedResourceUsages(event.resourceUsages);
    const totalResourceCount = sumBy(groupedUsages, "count");

    const inventoryNames = groupedUsages.map((usage) => {
        return <InventoryName key={usage.resource.id} disableTooltip eventResource={usage} />;
    });

    return <ShowResourceNames content={inventoryNames} count={totalResourceCount} showOnlyCount={showOnlyCount} />;
};
